import AdminDashboardQboSupportClearDuplicatesHtml from './admin-dashboard.qbo-support.clear-duplicates.html';
import CheckContactsMatchClearModalHtml            from './templates/support/qbo/checkContactsMatchClear.modal.html';
import ClearAllNonExistingContactsModalHtml        from './templates/support/qbo/clearAllNonExistingContacts.modal.html';
import FindProductByNameModalHtml                  from './templates/support/qbo/findProductByName.modal.html';
import RetrieveRecordModalHtml                     from './templates/support/qbo/retrieveRecord.modal.html';
import ViewBatchObjectModalHtml                    from './templates/support/qbo/viewBatchObject.modal.html';

export function QBOSupport ($uibModal, sessionObjAPI) {
  var QBOSupport = function() {};

  QBOSupport.prototype.retrieve_record_by_id = function (result, qbo_type) {
    return $uibModal.open({
      templateUrl: RetrieveRecordModalHtml,
      windowClass: 'lg-modal',
      controller: 'QBOSupportRetrieveRecordByIdCtrl',
      resolve: {
        result: [ function () {
          return result;
        }],
        qbo_type: [ function() {
          return qbo_type;
        }]
      }
    }).result;
  };

  QBOSupport.prototype.clear_all_non_existing_contacts = function (result) {
    return $uibModal.open({
      templateUrl: ClearAllNonExistingContactsModalHtml,
      windowClass: 'lg-modal',
      controller: 'QBOSupportClearAllNonExistingContactsCtrl',
      resolve: {
        result: [ function () {
          return result;
        }]
      }
    }).result;
  };

  QBOSupport.prototype.clear_duplicates = function (result) {
    return $uibModal.open({
      templateUrl: AdminDashboardQboSupportClearDuplicatesHtml,
      windowClass: 'lg-modal',
      controller: 'QBOSupportClearDuplicatesCtrl',
      resolve: {
        result: [ function () {
          return result;
        }]
      }
    }).result;
  };

  QBOSupport.prototype.check_contacts_match_and_clear = function (result) {
    return $uibModal.open({
      templateUrl: CheckContactsMatchClearModalHtml,
      windowClass: 'lg-modal',
      controller: 'QBOSupportCheckContactsMatchClearCtrl',
      resolve: {
        result: [ function () {
          return result;
        }]
      }
    }).result;
  };

  QBOSupport.prototype.view_batch_object = function (results) {
    return $uibModal.open({
      templateUrl: ViewBatchObjectModalHtml,
      windowClass: 'lg-modal flip-container',
      controller: 'QBOSupportViewBatchObjectCtrl',
      resolve: {
        results: [ function () {
          return results;
        }]
      }
    }).result;
  };


  QBOSupport.prototype.find_product_by_name= function (result) {
    return $uibModal.open({
      templateUrl: FindProductByNameModalHtml,
      windowClass: 'lg-modal flip-container',
      controller: 'QBOSupportFindProductByNameCtrl',
      resolve: {
        results: [ function () {
          return result;
        }]
      }
    }).result;
  };


  return QBOSupport;
}